// react
import React from 'react';

export default function FooterLayanan() {
    return (
        <div className="site-footer__widget footer-service">
            <h5 className="footer-title">Hubungi Kami</h5>
            <ul className="footer-info-list">
                <li className="footer-info-item">
                    <i className="fab fa-whatsapp footer-info-icon" />
                    <a
                        href="https://api.whatsapp.com/send/?phone=+6281230553236&text=Hallo%20Hokky%20Bangunan%20saya%20mau%20tanya."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        0812-3055-3236
                    </a>
                </li>
                <li className="footer-info-item">
                    <i className="far fa-envelope footer-info-icon" />
                    <a
                        href="mailto:hokkybangunan@gmail.com"
                        className="footer-link"
                    >
                        hokkybangunan@gmail.com
                    </a>
                </li>
            </ul>
        </div>
    );
}
